<section class="page-title">
    <h1>Claims</h1>
    <div class="employee-code">
        <button mat-raised-button mat-raised-button color="primary" class="oms-btn pull-right" (click)="openClaimDialog(claimModel)"> Add Claim </button>
    </div>
</section>
<mat-card class="card-white mb-4">
    <mat-card-title class="mb-0">
        <div class="card-white-title mb-0 cursor-pointer" [class.advanceSearchFilter]="isAdvanceSearchFilter" (click)="onDisplayFilter(null)">
            <div class="card-user-name">Advance Search or Filter</div>
            <div class="office-hours">
                <a class="box-arrow" (click)="onDisplayFilter($event)" href="javascript:void(0);">&nbsp;</a>
            </div>
        </div>
    </mat-card-title>
    <mat-card-content [hidden]="!isAdvanceSearchFilter" class="mt-3">
        <div class="example-form">
            <ul class="form-for-advance-search">
                <li class="col-12">
                    <mat-form-field class="example-full-width">
                        <input matInput [(ngModel)]="filterKey" (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                        <button *ngIf="filterKey" matSuffix mat-icon-button aria-label="Clear" (click)="filterKey='';applyFilter('')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </li>
            </ul>
        </div>
    </mat-card-content>
</mat-card>
<mat-card class="card-white matcardheight">
    <mat-card-content>
        <div class="row example-container">
            <div *ngIf="sortedClaimList != null && sortedClaimList.length > 0" class="accordion-table-container">
                <table class="list-table" mat-table [dataSource]="dataSource">
                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef>Claim Code </th>
                        <td mat-cell *matCellDef="let element"> 
                            <span>{{element.code}}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef>Description </th>
                        <td mat-cell *matCellDef="let element"> 
                            <span>{{element.description}}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let element" >
                            <ul class="action-items">
                                <li class="view-link">
                                    <a (click)="openClaimDialog(element)" class="me-3" href="javascript:void(0)"><i class="fa fa-pencil"></i></a>
                                </li>
                            </ul>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
            <mat-paginator #paginator [pageSize]="pageSize" [showFirstLastButtons]="true" [pageSizeOptions]="[5, 10, 20]"></mat-paginator>
            <div *ngIf="sortedClaimList == null || sortedClaimList.length <= 0" class="no-record-found">No record found.</div>
        </div>
    </mat-card-content>
</mat-card>